export default "__VITE_ASSET__CIzm3o53__"